import { withModel } from '../../../../js/view/data-providers/model';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import get from 'lodash/get';
import Offer from './Offer';

const enhance = compose(
  withModel,
  withProps(props => ({
    copiedNotificationText: get(props, 'model.prismicGlobalContentModel.general.copiedNotificationText', ''),
  }))
);

export default enhance(Offer);




// WEBPACK FOOTER //
// ./src/client/js/view/components/Offer/index.js